import { ReactElement, useMemo } from 'react';
import { Box, Stack, Table, Tbody, Td, Th, Thead, Tr } from '@ff-it/ui';
import { TableInlineColumn, TableInlines } from 'components';
import type { HourRange, RadioTimeBand, DayType } from '../types';
import { getBandlabel } from '../common/util';
import { dayTypeLabels } from '../common/const';
import { BandHourField } from '../common/BandHourField';

const initialValues = {
  start_hour: null,
  end_hour: null,
};

export function EditBandSet({ dayType }: { dayType: DayType }): ReactElement {
  const name = `bands.${dayType}`;

  const columns = useMemo(() => {
    return [
      {
        key: 'start_hour',
        content: dayTypeLabels[dayType],
        render: ({ name }) => (
          <Stack direction="horizontal">
            <Box flex={1}>
              <BandHourField name={name} boundary="start" />
            </Box>
            <Box>-</Box>
            <Box flex={1}>
              <BandHourField name={name} boundary="end" />
            </Box>
          </Stack>
        ),
      },
    ] as TableInlineColumn[];
  }, [dayType]);
  return (
    <TableInlines
      headerVariant="default"
      key={dayType}
      size="xs"
      sortable={false}
      name={name}
      columns={columns}
      initialValues={initialValues}
    />
  );
}
export function ViewBandSet({ dayType, bands }: { dayType: DayType; bands: RadioTimeBand[] }): ReactElement {
  return (
    <Table mb="3" size="xs" textSize="sm" fixed border="subtle">
      <Thead>
        <Tr>
          <Th> {dayTypeLabels[dayType]}</Th>
        </Tr>
      </Thead>
      <Tbody>
        {bands.map((band) => {
          return (
            // FIXME: see, type
            <Tr key={(band as HourRange & { id: number }).id}>
              <Td>{getBandlabel(band)}</Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
}
